import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

import { State as ConstraintsState } from '../../Constraints/redux';

const locationInStateSummary = (
  locationInState: ConstraintsState['locationInState'],
): JSX.Element | null => {
  if (!locationInState.active) {
    return null;
  }

  return (
    <Typography paragraph>
      Due to restrictions a membership may only engage with this offer if the transaction originates
      in one of the following states: <b>{locationInState.states.join(', ')}</b>.
    </Typography>
  );
};

const requiresActivationSummary = (
  requiresActivation: ConstraintsState['requiresActivation'],
): JSX.Element | null => {
  if (!requiresActivation.active) {
    return null;
  }

  const activateWithinComponent = requiresActivation.mustFulfillWithinDaysActive && (
    <>
      Once activated, the membership will have <b>{requiresActivation.mustFulfillWithinDays}</b> to
      fulfill the offer before it will no longer be valid.
    </>
  );

  return (
    <Typography paragraph>
      Before engaging with this offer we'd like the membership to positively signal their intent by{' '}
      <b>activating</b> first. {activateWithinComponent}
    </Typography>
  );
};

interface IProps {
  constraints: ConstraintsState;
}

export const ConstraintsSummary: React.FC<IProps> = ({ constraints }) => {
  const { locationInState, requiresActivation } = constraints;

  return (
    <Box>
      <Box>{requiresActivationSummary(requiresActivation)}</Box>
      <Box>{locationInStateSummary(locationInState)}</Box>
    </Box>
  );
};
